import _ from 'lodash';
import { connect } from 'react-redux';

import { FEATURE_FLAG_DISABLE_KEY, FEATURE_FLAG_DISABLE_ALL } from '../Actions';

const DEFAULT = { previewFeatureFlags: [], enabledFeatureFlags: [] };

export const featureFlagReducer = (state, action) => {
  const newState = _.cloneDeep(_.assign({}, DEFAULT, state));
  switch (action.type) {
    case FEATURE_FLAG_DISABLE_KEY:
      const flags = state.previewFeatureFlags.filter(flag => flag !== action.key);
      return _.assign({}, newState, { previewFeatureFlags: flags });
    case FEATURE_FLAG_DISABLE_ALL:
      return _.assign({}, newState, DEFAULT);
    default:
      return newState;
  }
};

export const disableKey = key => ({ type: FEATURE_FLAG_DISABLE_KEY, key });
export const disableAll = () => ({ type: FEATURE_FLAG_DISABLE_ALL });

export const connectFeatureFlag = connect(
  ({ featureFlag }) => ({
    ...featureFlag,
    isContractorReferral: featureFlag?.enabledFeatureFlags?.includes('contractor_referral'),
  }),
  { disableKey, disableAll },
  null,
  {
    forwardRef: true,
  }
);
